export const SEARCH_INPUT_SELECTOR = 'input.long-placeholder, input.short-placeholder';
